import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  premadeTemplates: {},
  sizeFormats: [],
  userFonts: {},
};

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setPremadeTemplates: (state, action) => {
      state.premadeTemplates = action.payload;
    },
    setSizeFormats: (state, action) => {
      state.sizeFormats = action.payload;
    },
    setUserFonts: (state, action) => {
      state.userFonts = action.payload;
    },
  },
});

export const { setPremadeTemplates, setSizeFormats, setUserFonts } =
  templatesSlice.actions;
export default templatesSlice.reducer;

// Selectors
export const selectPremadeTemplates = state => state.templates.premadeTemplates;
export const selectSizeFormats = state => state.templates.sizeFormats;
export const selectUserFonts = state => state.templates.userFonts;
